"use client"

import { Badge } from "@/components/ui/badge"
import { CircleAlert, TriangleAlert, Info } from "lucide-react"
import React from "react"

interface AlertItemRendererProps {
  item: any
  label: string
}

const getAlertIcon = (type: string) => {
  switch (type) {
    case "Error":
      return <CircleAlert className="w-6 h-6 fill-red-600 text-white" strokeWidth={2.5} />
    case "Warning":
      return <TriangleAlert className="w-6 h-6 fill-orange-500 text-white" strokeWidth={2.5} />
    case "Information":
      return <Info className="w-6 h-6" />
    default:
      return null
  }
}

const getAlertIconColor = (type: string) => {
  switch (type) {
    case "Error":
      return ""
    case "Warning":
      return ""
    case "Information":
      return "text-blue-500"
    default:
      return "text-gray-600"
  }
}

export function AlertItemRenderer({ item, label }: AlertItemRendererProps) {
  const alertType = item.type || item.Type || 'Information';
  
  return (
    <div className="flex items-center gap-2">
      <span className={getAlertIconColor(alertType)}>
        {getAlertIcon(alertType)}
      </span>
      <span className="text-gray-900">{label}</span>
    </div>
  )
}
